const RECAPTCHA_SITE_KEY = '6Le1t0YsAAAAAEi-PeuQJH3LXRECFZUX_YHLlGbl';

let recaptchaLoaded = false;
let recaptchaLoading = false;

const loadRecaptchaScript = () => {
  return new Promise((resolve) => {
    if (recaptchaLoaded && window.grecaptcha) {
      resolve();
      return;
    }
    if (recaptchaLoading) {
      // Wait for existing load
      const check = setInterval(() => {
        if (window.grecaptcha) { clearInterval(check); resolve(); }
      }, 100);
      setTimeout(() => { clearInterval(check); resolve(); }, 5000);
      return;
    }
    recaptchaLoading = true;
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.onload = () => { recaptchaLoaded = true; resolve(); };
    script.onerror = () => { recaptchaLoading = false; resolve(); };
    document.head.appendChild(script);
  });
};

export const getRecaptchaToken = async (action) => {
  // Load reCAPTCHA on demand (not on page load)
  await loadRecaptchaScript();
  
  return new Promise((resolve) => {
    if (!window.grecaptcha) {
      resolve(null);
      return;
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(RECAPTCHA_SITE_KEY, { action })
        .then(resolve)
        .catch(() => resolve(null));
    });
  });
};

export default getRecaptchaToken;
